import styled, { css, keyframes } from 'styled-components';
import { growlTypes } from 'store/ducks/ui';
import { colors } from '../../styles/colors';

export const Ul = styled.div`
  position: fixed;
  top: 100px;
  right: 50%;
  transform: translateX(50%);
  list-style: none;
  z-index: 20;
`;

const types = {
  [growlTypes.GROWL_ERROR]: css`
    background: ${colors.danger};
    border-color: ${colors.danger};
  `,
  [growlTypes.GROWL_SUCCESS]: css`
    background: ${colors.success};
    border-color: ${colors.success};
  `,
  [growlTypes.GROWL_INFO]: css`
    background: ${colors.info};
    border-color: ${colors.info};
  `,
};

const showalert = keyframes`
  from {
    opacity: 0;
    transform: translate(50%, -100%);
  }

  to {
    opacity: 1;
    transform: translate(50%, 0);
  }
`;

export const Li = styled.div`
  transition: transform 0.2s, opacity ease-out 0.2s;
  padding: 1rem 2rem;
  border-radius: 3px;
  width: 340px;
  max-width: 90vw;
  text-align: center;
  margin: 8px 0;
  box-shadow: rgba(84, 70, 35, 0.2) 0px 6px 10px;
  right: 50%;
  position: absolute;
  transform: translate(50%, 0);
  background: white;
  border: 1px solid ${colors.greyLighter};
  color: ${colors.white};

  ${({ type }) => types[type]}

  ${({ hidden }) => (hidden
    ? css`
          transform: translate(50%, -100%);
          opacity: 0;
        `
    : css`
          animation: ${showalert} 0.5s cubic-bezier(0.68, -0.55, 0.27, 1.55);
        `)}
`;
